import { Box, Button } from '@mui/material';
import { Google, Window } from '@mui/icons-material';
import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect, useRef } from 'react';

interface Props {
  onSocialSignup: (user: any) => void;
  onError: (error: string) => void;
}

function SocialsSignup({ onSocialSignup, onError }: Props) {
  const { user, loginWithRedirect, isAuthenticated } = useAuth0();
  const calledRef = useRef(false);

  useEffect(() => {
    if (
      isAuthenticated &&
      user &&
      !calledRef.current &&
      sessionStorage.getItem('social-signup-in-progress') === 'true'
    ) {
      onSocialSignup(user);
      calledRef.current = true;
      sessionStorage.removeItem('social-signup-in-progress');
    }
  }, [isAuthenticated, user, onSocialSignup]);

  const handleSocialSignup = useCallback(
    async (connection: 'google-oauth2' | 'windowslive') => {
      try {
        sessionStorage.setItem('social-signup-in-progress', 'true');
        await loginWithRedirect({
          authorizationParams: {
            connection,
          },
        });
      } catch (error) {
        if (onError) {
          onError(error instanceof Error ? error.message : 'Social sign up failed or was cancelled. Please try again.');
        }
      }
    },
    [loginWithRedirect, onError]
  );

  return (
    <Box>
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        fullWidth
        startIcon={<Google />}
        sx={{ mb: 2, py: 1.5 }}
        onClick={() => handleSocialSignup('google-oauth2')}
      >
        Sign Up with Google
      </Button>
      <Button
        color="secondary"
        size="small"
        variant="outlined"
        fullWidth
        startIcon={<Window />}
        sx={{ py: 1.5 }}
        onClick={() => handleSocialSignup('windowslive')}
      >
        Sign Up with Microsoft
      </Button>
    </Box>
  );
}

export { SocialsSignup };
